import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["status", "loading"]
  static values = { token: String }

  connect() {
    this.loadApiStatus()
  }

  async loadApiStatus() {
    if (!this.tokenValue) {
      this.showError("Token не найден")
      return
    }

    this.showLoading()

    try {
      const response = await fetch(`https://bovatech.cc/v1/p2p_transactions/${this.tokenValue}`)
      const data = await response.json()

      if (data.result_code === "ok") {
        this.showStatus(data.payload.state)
      } else {
        this.showError("Ошибка получения данных")
      }
    } catch (error) {
      this.showError("Ошибка соединения")
    }
  }

  showLoading() {
    this.loadingTarget.style.display = "block"
    this.statusTarget.style.display = "none"
  }

  showStatus(state) {
    this.loadingTarget.style.display = "none"
    this.statusTarget.style.display = "block"

    this.statusTarget.innerHTML = `
      <div class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${this.getStatusColor(state)}">
        ${this.getStatusText(state)}
      </div>
    `
  }

  showError(message) {
    this.loadingTarget.style.display = "none"
    this.statusTarget.style.display = "block"
    this.statusTarget.innerHTML = `
      <span class="text-red-600 text-sm">${message}</span>
    `
  }

  getStatusColor(state) {
    switch (state) {
      case 'paid':
      case 'successed':
      case 'accepted_successed':
      case 'repeated_accepted_successed':
        return 'bg-green-100 text-green-800'
      case 'created':
      case 'processing':
      case 'waiting_otp':
      case 'processing_otp':
      case 'waiting_payment':
        return 'bg-yellow-100 text-yellow-800'
      case 'reviewing':
      case 'repeated_reviewing':
        return 'bg-blue-100 text-blue-800'
      case 'failed':
      case 'rejected':
      case 'closed_failed':
      case 'repeated_closed_failed':
        return 'bg-red-100 text-red-800'
      default:
        return 'bg-gray-100 text-gray-800'
    }
  }

  getStatusText(state) {
    switch (state) {
      case 'created':
        return 'Создан'
      case 'processing':
        return 'Обрабатывается'
      case 'waiting_otp':
        return 'Ожидание OTP'
      case 'processing_otp':
        return 'Обработка OTP'
      case 'waiting_payment':
        return 'Ожидание оплаты'
      case 'paid':
        return 'Оплачен'
      case 'successed':
        return 'Успешно'
      case 'failed':
        return 'Неудачно'
      case 'rejected':
        return 'Отклонен'
      case 'reviewing':
        return 'Рассматривается'
      case 'repeated_reviewing':
        return 'Повторное рассмотрение'
      case 'closed_failed':
        return 'Закрыт неудачно'
      case 'repeated_closed_failed':
        return 'Повторно закрыт неудачно'
      case 'accepted_successed':
        return 'Принят успешно'
      case 'repeated_accepted_successed':
        return 'Повторно принят успешно'
      default:
        return state
    }
  }
}
